var moduleMap = {
	"./Protect": () => {
		return Promise.all([__webpack_require__.e(3700), __webpack_require__.e(8348), __webpack_require__.e(1178), __webpack_require__.e(7644), __webpack_require__.e(2036), __webpack_require__.e(5354), __webpack_require__.e(2412), __webpack_require__.e(4947), __webpack_require__.e(3381), __webpack_require__.e(6992), __webpack_require__.e(9881), __webpack_require__.e(3215), __webpack_require__.e(6965), __webpack_require__.e(3452), __webpack_require__.e(9271), __webpack_require__.e(9848), __webpack_require__.e(1605), __webpack_require__.e(9205), __webpack_require__.e(6697), __webpack_require__.e(8190), __webpack_require__.e(2133), __webpack_require__.e(1887)]).then(() => (() => ((__webpack_require__(52599)))));
	},
	"./Policies": () => {
		return Promise.all([__webpack_require__.e(3700), __webpack_require__.e(1178), __webpack_require__.e(2036), __webpack_require__.e(5354), __webpack_require__.e(3381), __webpack_require__.e(9881), __webpack_require__.e(3215), __webpack_require__.e(3452), __webpack_require__.e(9271), __webpack_require__.e(9848), __webpack_require__.e(9205), __webpack_require__.e(2133), __webpack_require__.e(8101)]).then(() => (() => ((__webpack_require__(27996)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});